import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import Card from '../../card';
import ViewContent from './view-content';
import EditContent from './edit-content';
import StationPropType from '../../../utils/prop-types/station';

const { canEditStationInfo } = require('../../../../lib/permissions').default;

class StationInformationCard extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    station: StationPropType,
  };

  static defaultProps = {
    isLoading: false,
    station: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: props.isLoading,
      station: props.station,
    };
  }

  componentDidUpdate = (prevProps) => {
    const { isLoading, station } = this.props;
    if (prevProps.isLoading !== isLoading
      || !_.isEqual(station, prevProps.station)) {
      this.setState(() => ({ isLoading, station }));
    }
  }

  handleWillSave = () => {
    this.setState(() => ({ isLoading: true }));
  }

  handleOnSaved = () => {
    this.setState(() => ({ isLoading: false }));
  }

  render = () => {
    const { station, isLoading } = this.state;

    let editModal = null;
    const showEditButton = canEditStationInfo();
    if (showEditButton) {
      editModal = (
        <EditContent
          willSave={this.handleWillSave}
          onSaved={this.handleOnSaved}
        />
      );
    }

    return (
      <Card
        title={`STATION INFORMATION - ${station.retailer_name} #${station.retailer_reference}`}
        showCollapseButton
        showEditButton={showEditButton}
        isLoading={isLoading}
        editModal={editModal}
      >
        <ViewContent />
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
  isLoading: state.loading,
});

export default connect(mapStateToProps)(StationInformationCard);
